<template>
    <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :searchs="searchs" :operate="[]" :permission="permission"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "AgentFrontTemplate",
        components: {CommonTable},
        data() {
            return {
                permission:{
                    add: 'agentFrontTemplate:add',
                    update: 'agentFrontTemplate:update',
                    delete: 'agentFrontTemplate:delete',
                    deleteBatch: 'agentFrontTemplate:deleteBatch'
                },
                url: {
                    get: '/agentFrontTemplate/listByCondition',
                    add: '/agentFrontTemplate/add',
                    update: '/agentFrontTemplate/update',
                    delete: '/agentFrontTemplate/delete/',
                    delete_batch: '/agentFrontTemplate/deleteBatch',
                },
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/top',
                    selectData: [],
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/top',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    width: '',
                }, {
                    field: 'name',
                    label: '模板名称',
                    show: true,
                    width: '',
                }, {
                    field: 'publicIp',
                    label: '公网IP',
                    show: true,
                    width: '',
                }, {
                    field: 'innerIp',
                    label: '内网IP',
                    show: true,
                    width: '',
                }, {
                    field: 'port',
                    label: '端口',
                    show: true,
                    width: '',
                },{
                    field: 'isInner',
                    label: '是否内网',
                    show: {
                        type: 'tag',
                        tags:[
                            {
                                key: 1,
                                value: '是',
                                type: 'success'
                            },{
                                key: 0,
                                value: '否',
                                type: 'warning'
                            }
                        ]
                    },
                    width: '80',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加代理前端模板',
                    updateTitle: '修改代理前端模板',
                    labelWidth: '80px',
                    model: [{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        placeholder: '请选择代理',
                        rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
                        selectUrl: '/agent/top',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }, {
                        field: 'frontTemplateId',
                        label: '前端模板',
                        type: 'select',
                        placeholder: '前端模板',
                        rules:[{required: true, message: '请选择前端模板', trigger: 'blur'}],
                        selectUrl: '/frontTemplate/getAll',
                        selectData: [],
                        add: true,
                        update: true,
                        filterable: true,
                    }]
                }
            }
        }
    }
</script>

<style scoped>

</style>
